var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{class:[
      'form-group',
      'warning-message',
      'col-12',
      'row',
      !_vm.hasCustomer ? 'd-none' : '',
    ]},[_c('div',{staticClass:"alert-danger p-2"},[_c('i',{staticClass:"fas fa-exclamation-triangle mr-1"}),_c('span',{staticClass:"text-uppercase font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('register.attention'))+":")]),_vm._v(" "+_vm._s(_vm.$t('warning.login-media-with-customer'))+" ")])]),_c('div',{staticClass:"form-group row mb-0 justify-content-md-center"},[_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-lg btn-block btn-success text-uppercase font-weight-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.login()}}},[_vm._v(" "+_vm._s(_vm.$t('login.access-personal-area'))+" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }